import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';

/* selector: useGetRegistrationList */

interface RegistrationListElement {
  registration_status_id: number;
  registration_id: number;
  applicant_id: number;
  username: string;
  company_name: string;
  type: string;
  vat_number: number;
  verified: boolean;
  status: string;
  registration_date: string;
  change_date: string;
  state: string;
  canBeUpdated: number;
}

interface RegistrationListData {
  paging: RegistrationListPaging;
  items: RegistrationListElement[];
}

interface RegistrationListPaging {
  page: number;
  pageSize: number;
  total: number;
}

interface RegistrationListOutput {
  status: StateStatus;
  data: RegistrationListData | null;
}

export const useGetRegistrationList = (): RegistrationListOutput => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.REGISTRATION_LIST_REDUCER].registrationList
  );
  // console.log('TTEST:', data);
  return data;
};
